import {useState, useEffect} from "react";
import {
  IEsgProjectWithSegmentsFromServer,
  IEsgResponseSingleFromCMS,
} from "../pages/Esg/EsgDashboard.type";

const useFetchDataEsgProjectById = (
  apiUrl: string,
  apiKey: string,
  projectId: string
) => {
  const [projectData, setProjectData] =
    useState<IEsgResponseSingleFromCMS<IEsgProjectWithSegmentsFromServer> | null>(
      null
    );
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!projectId) return;

    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const url = new URL(`${apiUrl}/${projectId}`);
    url.searchParams.set("populate", "*");

    fetch(url.href, {method: "GET", headers})
      .then((response) => response.json())
      .then((data) => {
        setProjectData(data);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrl, apiKey, projectId]);

  return {projectData, error};
};

export default useFetchDataEsgProjectById;
